// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__yE6Zk"};